import React, { useState, useEffect } from 'react';
import { Grid, Box, Modal, Stack, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

import EirChannelCategory from './EirChannelCategory';
import EirInformation from '../eir-information/EirInformation';

/**
 * @name EirActionModal - jsx component for reusable action modal
 * @param {boolean} open - specifies when modal is open or close.
 * @param {Function} handleClose - function to be executed when modal needs to be closed,(usually toggles value of open variable
 * @param {boolean} [disableCloseOnBackdropClick] - if true then modal will not close on clicking the modal backdrop.
 * @param {boolean} [disableCloseOnEscapeKeyDown] - if true then modal will not close on pressing escape key.
 */
const EirChannelModal = ({
  heading,
  id,
  open,
  handleClose,
  disableCloseOnBackdropClick,
  disableCloseOnEscapeKeyDown,
  tvChannels = [],
}) => {
  const theme = useTheme();
  const [dataColumn1, setDataColumn1] = useState([]);
  const [dataColumn2, setDataColumn2] = useState([]);

  const handleDefaultClose = (event, reason) => {
    if (
      !(
        (reason === 'backdropClick' && disableCloseOnBackdropClick === true) ||
        (reason === 'escapeKeyDown' && disableCloseOnEscapeKeyDown === true)
      )
    ) {
      handleClose();
    }
  };

  useEffect(() => {
    if (tvChannels.length > 0) {
      setDataColumn1(tvChannels?.filter(item => item.CategoryName !== 'Entertainment'));
      setDataColumn2(tvChannels?.filter(item => item.CategoryName === 'Entertainment'));
    }
  }, [tvChannels]);
  return (
    <Modal
      id={id}
      open={open}
      onClose={(event, reason) => {
        handleDefaultClose(event, reason);
      }}
      sx={styles(theme).modalRoot}
    >
      <Box sx={styles(theme).modalContainer}>
        <Stack direction='row' sx={styles(theme).channelContainer}>
          <EirInformation
            title={heading}
            style={{
              title: { ...styles(theme).title, marginTop: 0 },
              marginLeft: '2rem',
            }}
          />
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon style={{ color: theme.palette.primary.buttonColor, fontSize: 'inherit' }} />
          </IconButton>
        </Stack>
        <Grid container spacing={3} sx={styles(theme).modalContent}>
          <Grid
            item
            container
            sx={{ pl: '25px', marginTop: 0, ...styles(theme).subModalContent }}
            spacing={{ md: 5, xs: 0 }}
          >
            <Grid item xs={12} md={6} sx={{ paddingTop: '20px !important' }}>
              {dataColumn1.length > 0 &&
                dataColumn1?.map((ele, index) => <EirChannelCategory data={ele} key={index} />)}
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{ marginTop: { sm: '0rem' }, paddingTop: '20px !important' }}
            >
              {dataColumn2.length > 0 &&
                dataColumn2?.map((ele, index) => <EirChannelCategory data={ele} key={index} />)}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default EirChannelModal;
